(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["slieton-warranty-popup"] && !Shopify.designMode) return;
  try {
    (() => {
  const root = document.querySelector('[data-slieton-warranty-popup]');
  if (!root || root.dataset.initialized === 'true') return;
  root.dataset.initialized = 'true';

  const dialog = root.querySelector('dialog');
  const closeButtons = root.querySelectorAll('[data-slieton-warranty-close]');
  const success = root.querySelector('[data-slieton-warranty-success]');
  const registeredKey = 'slietonWarrantyPopupRegistered';
  const closedUntilKey = 'slietonWarrantyPopupClosedUntil';
  const closeForMs = 7 * 24 * 60 * 60 * 1000;

  const storage = {
    get(key) {
      try {
        return window.localStorage.getItem(key);
      } catch (error) {
        return null;
      }
    },
    set(key, value) {
      try {
        window.localStorage.setItem(key, value);
      } catch (error) {
        return null;
      }
    },
  };

  const openPopup = () => {
    root.hidden = false;
    if (typeof dialog.showModal === 'function' && !dialog.open) {
      dialog.showModal();
    } else {
      dialog.setAttribute('open', '');
    }
  };

  const closePopup = () => {
    storage.set(closedUntilKey, String(Date.now() + closeForMs));
    if (dialog.open && typeof dialog.close === 'function') {
      dialog.close();
    } else {
      dialog.removeAttribute('open');
    }
    root.hidden = true;
  };

  closeButtons.forEach((button) => button.addEventListener('click', closePopup));
  dialog.addEventListener('click', (event) => {
    if (event.target === dialog) closePopup();
  });
  dialog.addEventListener('cancel', () => {
    storage.set(closedUntilKey, String(Date.now() + closeForMs));
    root.hidden = true;
  });

  if (success) {
    storage.set(registeredKey, 'true');
    openPopup();
    return;
  }

  if (storage.get(registeredKey) === 'true') return;

  const closedUntil = Number(storage.get(closedUntilKey) || 0);
  if (closedUntil > Date.now()) return;

  window.setTimeout(openPopup, 5000);
})();
  } catch(e) { console.error(e); }
})();

})();
